import React, { useContext } from "react";
import { InputDate } from "../../controls";
import { Box, Paper } from "@mui/material";
import { AppContext } from "../../App";
import moment from "moment";
import { subDays } from "date-fns";

const HomeRepFilter = ({ sortDate, setSortDate }) => {
  const { authUser } = useContext(AppContext);
  const handleDate = (name, newVal) => {
    setSortDate((x) => ({ ...x, [name]: newVal }));
  };

  return (
    <Paper className="p-[5px]">
      <div className="flex flex-wrap gap-[15px] justify-between items-center">
        <div className="grid pl-2">
          <span className="text-[12px] text-slate-500">Welcome 🎉</span>
          <span className="text-[16px] text-slate-500 font-medium">
            {authUser?.fullName}
          </span>
        </div>

        <Box className="flex items-center justify-center gap-2">
          <InputDate
            size="small"
            variant="outlined"
            name="fromDate"
            value={sortDate.fromDate}
            views={["day", "month", "year"]}
            openTo="day"
            minDate={new Date("01/01/2000")}
            maxDate={subDays(new Date(sortDate.toDate), 1)}
            onChange={(date) =>
              handleDate("fromDate", new Date(date).toISOString())
            }
          />
          <span className=" text-[16px] text-gray-500">TO</span>
          <InputDate
            size="small"
            variant="outlined"
            name="toDate"
            value={sortDate.toDate}
            minDate={moment(sortDate.fromDate, "MM/DD/YYYY").add(1, "days")}
            views={["day", "month", "year"]}
            openTo="day"
            onChange={(date) =>
              handleDate("toDate", new Date(date).toISOString())
            }
          />
        </Box>
      </div>
    </Paper>
  );
};

export default HomeRepFilter;
